import script from "./WithdrawalTokenSelectSub.vue?vue&type=script&setup=true&lang=ts"
export * from "./WithdrawalTokenSelectSub.vue?vue&type=script&setup=true&lang=ts"

import "./WithdrawalTokenSelectSub.vue?vue&type=style&index=0&id=6d81e287&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d81e287"]])

export default __exports__